import API from "./API";

export default class EPIS extends API
{

    static async all(filter) {
        return this.get("api/admin/epis");
    }

    static async search(filter) {
        return this.get("/api/admin/epis/search", { params: filter });
    }

    static async getRisks() {
        return this.get("api/admin/epis/get-risks");
    } 

    static async getEpi(id){ 
        return this.get("api/admin/epis/get-epi/" + id);
    }

    static async getUserEpis(id) {
        let params = {
            Codigo: id
        }
        return this.get("api/admin/epis/get-user-epis", {params: params});
    }

    static async getUserInEpis() {
        return this.get("api/admin/epis/get-users-in-epis");
    }

    static async registerEPIUser(params) {
        return this.post("api/admin/epis/register-epi-user", params);
    }

    static async registerExit(params) {
        return this.post("api/admin/epis/register-epi-exit/" + params.id, params);
    }

}